@if (isPipMode && media?.media_type && media?.media_value) {
  <div class="pip-player" [class.fullscreen]="isExternal" cdkDrag cdkDragRootElement=".pip-player">
    <div class="pip-header d-flex justify-content-between align-items-center px-2 py-1" [class.d-none]="isExternal">
      <button type="button" class="btn text-white" (click)="closePip()">
        <i class="ri-close-fill"></i>
      </button>
      <span class="fw-bold">{{ media?.title }}</span>
      <button type="button" class="btn text-white" (click)="openModalAgenda()">
        <i class="ri-external-link-fill"></i>
      </button>
    </div>
    <div class="pip-body">
      @if (media?.header_image_url) {
        <img [src]="media?.header_image_url" class="w-100 object-fit-cover" alt="header_image_url" />
      }
      @if (media?.media_type === mediaType.YOUTUBE) {
        <iframe
          [src]="
            'https://www.youtube.com/embed/' + media?.media_value + '?autoplay=1&mute=1' | sanitizer: 'resourceUrl'
          "
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        ></iframe>
      }
      @if (media?.media_type === mediaType.VIMEO) {
        <iframe
          [src]="'https://player.vimeo.com/video/' + media?.media_value | sanitizer: 'resourceUrl'"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
        ></iframe>
      }
      @if (media?.media_type === mediaType.ZOOM) {
        <iframe
          [src]="media?.media_value || '' | sanitizer: 'resourceUrl'"
          frameborder="0"
          allow="microphone; camera; fullscreen"
        ></iframe>
      }
      @if (media?.media_type === mediaType.RTMP) {
        <iframe
          [src]="media?.media_value || '' | sanitizer: 'resourceUrl'"
          frameborder="0"
          allow="microphone; camera; fullscreen"
        ></iframe>
      }
      @if (media?.media_type === mediaType.BLUEJEANS) {
        <div class="iframe-container" [innerHTML]="media?.media_value || '' | sanitizer: 'html'"></div>
      }
      @if (media?.media_type === mediaType.OTHER) {
        <div class="iframe-container" [innerHTML]="media?.media_value || '' | sanitizer: 'html'"></div>
      }
    </div>
  </div>
}
